"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDataSets = exports.getPlotColor = void 0;
var COLORS_MAP = {
    'main-lavender': '#7D7198',
    'main-ocean': '#3A7B92',
    'main-tangerine': '#F9A911',
};
var getPlotColor = function (colorString) { return COLORS_MAP[colorString] || colorString; };
exports.getPlotColor = getPlotColor;
var buildDataSets = function (dataSets, isComparison) { return dataSets.map(function (d) { return ({
    label: d.label,
    unit: d.unit,
    data: d.data,
    borderColor: (0, exports.getPlotColor)(d.color),
    opacity: isComparison ? 0.5 : 1,
    yAxisID: d.side,
    pointBackgroundColor: (0, exports.getPlotColor)(d.color),
    pointBorderColor: 'white',
    pointHoverBorderColor: (0, exports.getPlotColor)(d.color),
    pointRadius: 0,
    hoverRadius: 4,
    borderWidth: 2,
    borderDash: isComparison ? [5, 5] : [],
}); }); };
exports.buildDataSets = buildDataSets;
